import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of, switchMap, take, tap } from 'rxjs';
import { ManutenzioneSseService } from '../services/web/manutenzione-sse.service';

export const maintenanceGuard: CanActivateFn = () => {
  const router = inject(Router);
  const maintenanceService = inject(ManutenzioneSseService);

  //  richiama il metodo che fa polling e caching
  return maintenanceService.getManutenzioneStatusNoAuth().pipe(
    take(1), // prendiamo solo il primo valore utile
    tap((isInMaintenance) => {
      if (isInMaintenance) {
        router.navigate(['/manutenzione']);
      }
    }),
    map((isInMaintenance) => !isInMaintenance), // true = lascia passare, false = blocca
    catchError((err) => {
      console.error('Errore nel controllo manutenzione:', err);
      // In caso di errore, lasciamo passare per evitare blocchi
      return of(true);
    }),
  );
};
